import React from 'react';
import { useFormikContext } from 'formik';

import MenuItem from '~/components/core/Atomic/MenuItem';
import Tooltip from '~/components/core/Atomic/Tooltip';
import useOrganization from '~/components/OrganizationContext';
import type { CategoryModel } from '~/components/SystemConfiguration/NotificationsConfiguration/NotificationsCategories';
import TextFieldFormik from '~/components/TextFieldFormik';
import { CLAIM_NOTIFICATIONS_PRIORITY } from '~/Types';

interface PriorityCategoryFieldsFormikInnerProps {
  disabled?: boolean;
}

const PriorityCategoryFieldsFormikInner: React.FC<PriorityCategoryFieldsFormikInnerProps> = ({ disabled }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { notificationCategories, isLoadingNotificationCategories, isErrorNotificationCategories } = useOrganization();
  const { isSubmitting } = useFormikContext();

  const enabledCategories = notificationCategories?.filter((category: CategoryModel) => !category.is_disabled) || [];

  return (
    <div className="grid grid-cols-2 gap-8">
      <TextFieldFormik
        id="priority"
        label="Priority"
        disabled={disabled || isSubmitting}
        className="my-4"
        fullWidth
        select
      >
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*@ts-ignore*/}
        {Object.keys(CLAIM_NOTIFICATIONS_PRIORITY).map((priority: keyof typeof CLAIM_NOTIFICATIONS_PRIORITY) => (
          <MenuItem key={priority} value={priority}>
            {CLAIM_NOTIFICATIONS_PRIORITY[priority]}
          </MenuItem>
        ))}
      </TextFieldFormik>
      {!isLoadingNotificationCategories && !isErrorNotificationCategories ? (
        <Tooltip
          title={enabledCategories.length === 0 ? 'No categories configured yet' : ''}
          disabled={enabledCategories.length > 0}
        >
          <div>
            <TextFieldFormik
              id="category_id"
              label="Category"
              disabled={disabled || isSubmitting || enabledCategories.length === 0}
              className="my-4"
              fullWidth
              select
            >
              {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
              {/*@ts-ignore*/}
              {enabledCategories.map((category: CategoryModel) => (
                <MenuItem key={category.key} value={category.id}>
                  {category.label}
                </MenuItem>
              ))}
            </TextFieldFormik>
          </div>
        </Tooltip>
      ) : null}
    </div>
  );
};

export default PriorityCategoryFieldsFormikInner;
